import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Input,
  Row,
  Col,
  Button,
  Card,
  CardBody
} from "reactstrap";

import axios from "axios";
import "../Assets/css/style.css";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../Partials/adminsidebar";

const Leaderboard = () => {

  const token = localStorage.getItem("admin_token");

  const [leaderboard, setLeaderboard] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const handleReturn = () => {
    navigate("/admin-candidates");
  };
  const fetchLeaderboard = async () => {

    const res = await axios.get(
      // "http://localhost/qads_interview/result/leaderboard.php",
      "https://interview.qads.co.in/qads_interview/result/leaderboard.php",
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          page,
        }
      }
    );

    setLeaderboard(res.data.data.leaderboard);
    setTotalPages(res.data.data.pagination.total_pages);
  };

  useEffect(() => {
  fetchLeaderboard();
}, [page]);

  return (

    <div style={{ display: "flex" }}>

  {/* Sidebar */}
  <AdminSidebar />

  {/* Main Content Area */}
  <div style={{
    marginLeft: "250px",
    width: "100%",
    padding: "20px"
  }}>

    <Container className="mt-4">

      <Row className="align-items-center mb-3">

        {/* Title - Left */}
        <Col>
          <h3 className="leaderboard-title text-start mb-0">
            Interview Leaderboard
          </h3>
        </Col>

        

      </Row>

      {/* TABLE */}
      <Card className="leaderboard-card">
        <CardBody>

          <Table hover responsive>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Domain</th>
                <th>Score</th>
                <th>Percentage</th>
              </tr>
            </thead>

            <tbody>
              {leaderboard.map((row) => (
                <tr key={row.user_id}>
                  <td>
                    <span className="rank-badge">
                      {row.rank}
                    </span>
                  </td>

                  <td>{row.name}</td>
                  <td>{row.domain}</td>

                  <td>
                    {row.obtained_marks ?? "-"}
                  </td>

                  <td>
                    <span className="percentage-text">
                      {row.percentage ?? "-"} %
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>

          </Table>

          {/* PAGINATION */}
          <div className="text-center mt-3">
            <Button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="me-2 theme-btn"
            >
              Previous
            </Button>

            <Button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="theme-btn"
            >
              Next
            </Button>
          </div>

        </CardBody>
      </Card>

    

    </Container>

  </div>

</div>
    
  );
};

export default Leaderboard;